const errorHandler = {
  handleAPIError(error) {
    if (error.response) {
      const {
        response: { status, data },
      } = error;
      if (status === 500) {
        const message = (data && data.message) ? data.message : 'internal server error';
        throw message;
      } else if (status === 401) {
        const message = (data && data.message) ? data.message : 'Invalid credentials';
        throw message;
      } else if (status === 404) {
        throw 'Endpoint not found. Please contact support.';
      } else {
        const message = (data && data.message) ? data.message : 'An error occurred';
        throw message;
      }
    } else {
      throw error.message || 'Network error. Please check your connection.';
    }
  },
};

export default errorHandler;
